<section class="px-lg-5 px-5 page-center-card">

    <div class="card bg-transparent text-center border-0">
        <i class="mdi mdi-file-cancel-outline f-80 text-muted"></i>
        <h1 class="text-muted text-center f-30 mt-4 fw-300">PÁGINA NÃO ENCONTRADA</h1>
        <p [style.maxWidth.px]="350" class="mx-auto mt-3 text-muted f-20 fw-300">
            Esta página não existe ou você não possui permissão para acessá-la
        </p>
    </div>

</section>